const SET_BASKET = 'SET_BASKET';

export { SET_BASKET };
